export interface Gauge {
  id: number | string;
  count: number;
  label: string;
  color?: string;
  evolution?: number;
  avatar?: string;
  isPhantom?: boolean;
  isHidden?: boolean;
}

export type MainUnit = "percentage" | "total" | "rating";
export type SecondaryUnit = "total" | "percentage" | "evolution" | "none";
export type Sort = "alpha" | "mainValue" | "default";
export type Order = "asc" | "desc";

export const LINE_HEIGHT = 53;
export const ANIMATION_DELAY = 800;
